"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostMaintenanceStartResponse = instanceOfApiPostMaintenanceStartResponse;
exports.ApiPostMaintenanceStartResponseFromJSON = ApiPostMaintenanceStartResponseFromJSON;
exports.ApiPostMaintenanceStartResponseFromJSONTyped = ApiPostMaintenanceStartResponseFromJSONTyped;
exports.ApiPostMaintenanceStartResponseToJSON = ApiPostMaintenanceStartResponseToJSON;
exports.ApiPostMaintenanceStartResponseToJSONTyped = ApiPostMaintenanceStartResponseToJSONTyped;
/**
 * Check if a given object implements the ApiPostMaintenanceStartResponse interface.
 */
function instanceOfApiPostMaintenanceStartResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isOn' in value) || value['isOn'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function ApiPostMaintenanceStartResponseFromJSON(json) {
    return ApiPostMaintenanceStartResponseFromJSONTyped(json, false);
}
function ApiPostMaintenanceStartResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'isOn': json['is_on'],
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
    };
}
function ApiPostMaintenanceStartResponseToJSON(json) {
    return ApiPostMaintenanceStartResponseToJSONTyped(json, false);
}
function ApiPostMaintenanceStartResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'is_on': value['isOn'],
        'start_time': ((value['startTime']).toISOString()),
        'end_time': ((value['endTime']).toISOString()),
    };
}
